module.exports = __webpack_public_path__ + "img/product_abraxane_logo.228c3e78.png";